var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 205,
    viewBox: "0 0 507 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_7938)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76,
    width: 481,
    height: 205,
    rx: 10,
    fill: "#E8E2F4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_687_7938)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.355 125.947L404.614 68.3595L452.878 151.948C453.018 152.193 453.22 152.396 453.464 152.536C453.708 152.677 453.985 152.75 454.267 152.749C454.535 152.749 454.816 152.673 455.047 152.538C455.812 152.092 456.082 151.117 455.637 150.346L441.444 125.753L454.154 103.758L501.028 184.945H307.972L354.846 103.757L382.788 152.14C382.928 152.385 383.131 152.588 383.375 152.729C383.619 152.869 383.896 152.943 384.178 152.942C384.455 152.942 384.725 152.864 384.966 152.726C385.731 152.286 386.011 151.308 385.567 150.54L371.355 125.947Z",
    fill: "#C4B5E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.747 183.344L354.847 106.96L381.402 152.942C381.987 153.971 383.064 154.544 384.178 154.544C384.736 154.544 385.283 154.396 385.765 154.115C387.313 153.229 387.823 151.268 386.955 149.739L373.205 125.947L404.614 71.5626L451.491 152.75C452.076 153.779 453.153 154.351 454.267 154.351C454.796 154.351 455.362 154.215 455.854 153.923C457.384 153.037 457.912 151.08 457.025 149.546L443.294 125.754L454.154 106.96L498.254 183.344H310.747V183.344ZM435.664 25.165L430.3 32.9802C429.94 33.5159 429.748 34.1468 429.748 34.7924C429.748 35.4379 429.94 36.0688 430.3 36.6045L435.664 44.4198H407.806V25.165H435.664ZM506.565 184.946L456.931 98.9522C456.345 97.9608 455.288 97.3506 454.155 97.3506C453.592 97.3489 453.038 97.4962 452.551 97.7774C452.063 98.0587 451.659 98.464 451.378 98.9522L439.593 119.348L407.806 64.2988V50.8268H441.746C442.936 50.8268 444.031 50.1694 444.579 49.1155C444.847 48.5991 444.971 48.0199 444.938 47.439C444.904 46.858 444.715 46.2968 444.39 45.8143L436.835 34.79L444.39 23.7712C444.715 23.2884 444.904 22.7268 444.938 22.1455C444.971 21.5643 444.847 20.9848 444.579 20.468C444.031 19.4162 442.936 18.7587 441.746 18.7587H407.806V18.4548C407.806 16.6851 406.371 15.2517 404.614 15.2517C402.839 15.2517 401.403 16.6851 401.403 18.4548V64.2988L369.522 119.541L357.624 98.9522C357.343 98.464 356.939 98.0587 356.451 97.7774C355.964 97.4962 355.41 97.3489 354.847 97.3506C353.714 97.3506 352.656 97.9608 352.071 98.9522L302.436 184.946C302.149 185.43 301.997 185.983 301.997 186.547C301.997 187.11 302.149 187.663 302.436 188.147C303.003 189.141 304.06 189.749 305.212 189.749H503.789C504.941 189.749 505.999 189.141 506.565 188.147C506.853 187.663 507.005 187.11 507.005 186.547C507.005 185.983 506.853 185.43 506.565 184.946Z",
    fill: "#8A6CC8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_7938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 507,
    height: 205,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_687_7938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(302)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIllustration);
export default __webpack_public_path__ + "static/media/mission-illustration.ffdc852938710bf382d6a61a117ff019.svg";
export { ForwardRef as ReactComponent };